module.exports = __webpack_public_path__ + "img/m10.229cfe60.png";